module.exports = __webpack_public_path__ + "static/media/Kuehne.60f5c023.svg";